import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

function CategoryBox({ category = {
  sponsor: null,
  prizes: {
    third_place: [],
  },
}, imgPath, sponsorImgPath }) {
  const sponsorImgUrl = sponsorImgPath.length > 0 ? sponsorImgPath : ''
  const prizesListsClass = category.prizes.total_values.third_place > 0 ? 'col-md-4' : 'col-md-6'

  const backgroundPositionTop = category.slug === 'illustration_environment' || category.slug === 'concept_character' ? 'is-background-top' : ''

  const prizesByPlace = ((prizes) => {
    return (
      <ul>
        {prizes.map((prize, index) => {
          return (
            <li key={index} className="u-mb10">
              {prize.prize} <span className="text-green text-semibold">{prize.sponsor}</span> (value {numeral(prize.value).format('$0,0')})
            </li>
          )
        })}
      </ul>
    )
  })

  return (
    <div className="row">
      <div className="category-box col-12">
        <div className={`category-box__header ${backgroundPositionTop}`} style={{ backgroundImage: `url(${imgPath})` }}>
          <div className="category-box__header-info-background" />
          <div className="category-box__header-info">
            <h3>{category.title}</h3>
            <p>{category.description}</p>
          </div>
        </div>

        <div className="category-box__prizes">
          <div className="row u-text-left">
            <div className={`col-12 ${prizesListsClass} prizes-list`}>
              <div className="prizes__total-value">
                <span className="text-semibold">First place</span> - total
                value: <span className="text-semibold">{numeral(category.prizes.total_values.first_place).format('$0,0')}</span>
              </div>
              {prizesByPlace(category.prizes.first_place)}
            </div>
            <div className={`col-12 ${prizesListsClass} prizes-list`}>
              <div className="prizes__total-value">
                <span className="text-semibold">Second place</span> - total
                value: <span className="text-semibold">{numeral(category.prizes.total_values.second_place).format('$0,0')}</span>
              </div>
              {prizesByPlace(category.prizes.second_place)}
            </div>
            {category.prizes.total_values.third_place > 0
              && (
              <div className={`col-12 ${prizesListsClass} prizes-list`}>
                <div className="prizes__total-value">
                  <span className="text-semibold">Third place</span> - total
                  value: <span className="text-semibold">{numeral(category.prizes.total_values.third_place).format('$0,0')}</span>
                </div>
                {prizesByPlace(category.prizes.third_place)}
              </div>
              )
            }
          </div>
        </div>

        {category.sponsor
          && (
          <div className="categor-box__partner">
            <div><small>Category presented by:</small></div>
            <a href={category.sponsor.url} target="_blank">
              <img src={sponsorImgUrl} alt={category.sponsor.name} />
            </a>
          </div>
          )
        }
      </div>
    </div>
  )
}

CategoryBox.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    sponsor: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      url: PropTypes.string,
    }),
    prizes: PropTypes.shape({
      total_values: PropTypes.shape({
        first_place: PropTypes.number.isRequired,
        second_place: PropTypes.number.isRequired,
        third_place: PropTypes.number.isRequired,
      }).isRequired,
      first_place: PropTypes.array.isRequired,
      second_place: PropTypes.array.isRequired,
      third_place: PropTypes.array,
    }).isRequired,
  }).isRequired,
  imgPath: PropTypes.string.isRequired,
  sponsorImgPath: PropTypes.string.isRequired,
}

export default CategoryBox
